import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import SelectMultiplo from '../SelectMultiplo';
import { FaTimes, FaPlus, FaImage, } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { SlOptionsVertical } from 'react-icons/sl';
import { ServicoContext } from '../../context/ServicoContext';
import moment from 'moment';

function ModalObterServico({ setModalEditarServico }) {
    const { ListaOrganizacaoServico, ServicoOrganizacao, ListaLocalidadeServico, ServicoLocalidadeEditar, ListaAreaServico, ServicoArea, ListaPraticaServico, ServicoPratica, ListaFornecedorServico, ServicoFornecedor, ListaAnexoServico, FileServico, ListaLink, Link, ListaSistemaServico, ServicoSistema, ObterServico, BaixarAnexoServico, ServicoObter } = useContext(ServicoContext)
    const [organizacoesSelecionadas, setOrganizacoesSelecionadas] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);
    const [praticasSelecionadas, setPraticasSelecionadas] = useState([]);
    const [fornecedoresSelecionados, setFornecedoresSelecionados] = useState([]);
    const [localidadesSelecionadas, setLocalidadesSelecionadas] = useState([]);

    useEffect(() => {
        ObterServico()
        ListaOrganizacaoServico()
        ListaLocalidadeServico()
        ListaAreaServico()
        ListaPraticaServico()
        ListaFornecedorServico()
        ListaAnexoServico()
        ListaLink()
        ListaSistemaServico()
    }, [])

    useEffect(() => {
        if (ServicoOrganizacao && ServicoOrganizacao.length > 0) {
            const selecionadas = ServicoOrganizacao.map((item) => ({
                label: item?.organizacao?.nome,
                value: item?.organizacao?.key,
            }));
            setOrganizacoesSelecionadas(selecionadas);
        }
    }, [ServicoOrganizacao]);

    useEffect(() => {
        if (ServicoArea && ServicoArea.length > 0) {
            const selecionadas = ServicoArea.map((item) => ({
                label: item?.area?.descricao,
                value: item?.area?.key,
            }));
            setAreasSelecionadas(selecionadas);
        }
    }, [ServicoArea]);

    useEffect(() => {
        if (ServicoPratica && ServicoPratica.length > 0) {
            const selecionadas = ServicoPratica.map((item) => ({
                label: item.praticasReferencia.nome,
                value: item.praticasReferencia?.key,
            }));
            setPraticasSelecionadas(selecionadas);
        }
    }, [ServicoPratica]);

    useEffect(() => {
        if (ServicoFornecedor && ServicoFornecedor.length > 0) {
            const selecionadas = ServicoFornecedor.map((item) => ({
                label: item.fornecedor.fantasia,
                value: item.fornecedor?.key,
            }));
            setFornecedoresSelecionados(selecionadas);
        }
    }, [ServicoFornecedor]);

    useEffect(() => {
        if (ServicoLocalidadeEditar && ServicoLocalidadeEditar.length > 0) {
            const selecionadas = ServicoLocalidadeEditar.map((item) => ({
                label: item.localidade.nome,
                value: item.localidade?.key,
            }));
            setLocalidadesSelecionadas(selecionadas);
        }
    }, [ServicoLocalidadeEditar]);

    return (
        <div className="modal-novo" style={{ zIndex: 9999 }}>
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Serviço</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarServico(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Geral</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.descricao} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Grupo</Form.Label>
                                            <Form.Control value={ServicoObter?.grupo?.descricao} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Subgrupo</Form.Label>
                                            <Form.Control value={ServicoObter?.subGrupo?.descricao} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Item</Form.Label>
                                            <Form.Control value={ServicoObter?.item?.descricao} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dono do Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.pessoaDono?.nome} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Executor do Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.pessoaExecutor?.nome} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.tipoServico?.nome} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Empresas Atendidas</Form.Label>
                                            <SelectMultiplo
                                                value={organizacoesSelecionadas}
                                                placeholder=""
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Local de Execução</Form.Label>
                                            <SelectMultiplo
                                                value={localidadesSelecionadas}
                                                placeholder=""
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área Solicitante</Form.Label>
                                            <SelectMultiplo
                                                value={areasSelecionadas}
                                                placeholder=""
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Método Solicitação</Form.Label>
                                            <Form.Control value={ServicoObter?.metodoSolicitacao?.nome || ""} readOnly />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="nivel" title={<span>Nível de Serviço</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opção</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Atendimento</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Control value={ServicoObter?.slaAtendimento?.nome} readOnly />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Solução</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Control value={ServicoObter?.slaSolucao?.nome} readOnly />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Periodicidade de Solicitação</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Control value={ServicoObter?.periodicidade?.nome} readOnly />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Período de Cobertura</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Control value={ServicoObter?.cobertura?.nome} readOnly />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Práticas de Referência</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <SelectMultiplo
                                                value={praticasSelecionadas}
                                                placeholder=""
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fornecedores</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <SelectMultiplo
                                                value={fornecedoresSelecionados}
                                                placeholder=""
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="obs" title={<span>Observações</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Objetivo do Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.objetivo} readOnly as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Escopo do Serviço</Form.Label>
                                            <Form.Control value={ServicoObter?.escopo} readOnly as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Exclusões</Form.Label>
                                            <Form.Control value={ServicoObter?.exclusoes} as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="anexos" title={<span>Anexos</span>}>
                                <div style={{ maxHeight: '450px', overflow: 'auto' }}>
                                    {Link.length > 0 && "Links adicionados:"}
                                    {Link.length > 0 ? Link?.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <div className="secao-link" style={{ marginTop: '10px' }}>
                                                    <div key={item.keyLink} className="content-comentario">
                                                        <div style={{ width: '40%' }}>
                                                            <div className="div-comentario">
                                                                <p className="p-title">Usuário: </p>
                                                                <span>{item.nome}</span>
                                                            </div>
                                                            {moment(item.dataHora).format('L')} às {moment(item.dataHora).format('LT')}
                                                        </div>
                                                        <div className="div-link">
                                                            <p className="p-title">Link: </p>
                                                            <p><a href={item.link} target="_blank">{item.link}</a></p>
                                                        </div>
                                                        <div className="div-comentario">
                                                            <p className="p-title">Comentário: </p>
                                                            <span><p >{item.descricao}</p></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                        :
                                        <p>Nenhum link adicionado.</p>
                                    }
                                    <hr />
                                    <div>
                                        {FileServico.length > 0 && "Anexos adicionados:"}
                                        <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', maxHeight: '300px', overflow: 'auto' }}>
                                            {FileServico.length > 0 ? FileServico?.map((item, index) => {
                                                return (
                                                    <div key={index} style={{marginTop: '10px'}}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', marginBottom: '10px' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <FaImage style={{ fontSize: '40px' }} />
                                                                <span style={{ wordBreak: 'break-word' }}>{item.nomeArquivo}</span>
                                                            </div>
                                                            <div className="div-button">
                                                            <button type="button" className="btn-download" onClick={() => BaixarAnexoServico(item?.key)}><FiDownload /></button>
                                                        </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                                :
                                                <p>Nenhum anexo adicionado.</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="sistemas" title={<span>Aplicações</span>}>
                                <h1 className='h1-modal'>Aplicações</h1>
                                <Row>
                                    <div style={{ minHeight: '30vh', width: '100%' }}>
                                        {ServicoSistema.length > 0 ? ServicoSistema.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario">
                                                            <SlOptionsVertical style={{ marginRight: '15px' }} />
                                                            <span><div dangerouslySetInnerHTML={{ __html: item.sistema.nome }} /></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                            :
                                            <p>Nenhuma aplicação adicionada.</p>
                                        }
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ModalObterServico